import React, { useState } from "react";
import Cover from "../../components/cover/cover";
import { Container } from "react-bootstrap";
import { Image as ImageIcon } from "lucide-react";
import { ContactUs as ContactUsAPI } from "../../services/api";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useLocation } from "react-router-dom";
import "./style.css";
import Navigation, { getContainerClass } from "../../components/navigation/navigation";
// import Header from "../../components/header/header";
import { CircularProgress } from '@mui/material';

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: "",
    subject: "",
    message: "",
    image: ""
  });
  const [selectedImage, setSelectedImage] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errors, setErrors] = useState({});

  const breadcrumb = ["Home", "Contact Us"];
  const location = useLocation();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });

    if (errors[name]) {
      setErrors({
        ...errors,
        [name]: ""
      });
    }
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedImage(URL.createObjectURL(file));

      const reader = new FileReader();
      reader.onloadend = () => {
        setFormData({
          ...formData,
          image: reader.result
        });
      };
      reader.readAsDataURL(file);
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = "Name is required";
    }

    if (!formData.subject.trim()) {
      newErrors.subject = "Subject is required";
    }

    if (!formData.message.trim()) {
      newErrors.message = "Message is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      toast.error("Please fill in all required fields");
      return;
    }

    setIsSubmitting(true);

    try {
      const response = await ContactUsAPI(formData);

      if (response.data.status) {
        toast.success(response.data.message || "Your message has been sent successfully!");
        setFormData({
          name: "",
          subject: "",
          message: "",
          image: ""
        });
        setSelectedImage(null);
      } else {
        toast.error(response.data.message || "Failed to send message");
      }
    } catch (error) {
      console.error("Contact form submission error:", error);
      toast.error(error.response?.data?.message || "An error occurred while sending your message");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <div className={getContainerClass(location.pathname)}>
        {/* <Header/> */}
        <Cover breadcrumb={breadcrumb} page="contactus" />
        <Container style={{}} className="facilities-container">
          <h1 className="container-title">Contact Us</h1>
          <div className="contactus-content">
            <form className="contactus-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <input
                  type="text"
                  name="name"
                  placeholder="Name"
                  value={formData.name}
                  onChange={handleInputChange}
                  className={errors.name ? "error" : ""}
                />
                {errors.name && <span className="error-message">{errors.name}</span>}
              </div>

              <div className="form-group">
                <input
                  type="text"
                  name="subject"
                  placeholder="Subject"
                  value={formData.subject}
                  onChange={handleInputChange}
                  className={errors.subject ? "error" : ""}
                />
                {errors.subject && <span className="error-message">{errors.subject}</span>}
              </div>

              <div className="form-group">
                <textarea
                  name="message"
                  placeholder="Message"
                  value={formData.message}
                  onChange={handleInputChange}
                  className={errors.message ? "error" : ""}
                ></textarea>
                {errors.message && <span className="error-message">{errors.message}</span>}
              </div>

              <label className="image-upload-wrapper">
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleImageChange}
                  hidden
                />
                <div className="image-upload-box">
                  <span>Upload image</span>
                  <ImageIcon size={20} />
                </div>
              </label>

              {selectedImage && (
                <div className="image-preview-container">
                  <img src={selectedImage} alt="Preview" className="preview-img" />
                  <button
                    type="button"
                    className="remove-image-btn"
                    onClick={() => {
                      setSelectedImage(null);
                      setFormData({
                        ...formData,
                        image: ""
                      });
                    }}
                  >
                    Remove
                  </button>
                </div>
              )}

              <button
                type="submit"
                disabled={isSubmitting}
              >
                {isSubmitting ? <CircularProgress size={24} color="inherit" /> : "Send message"}
              </button>
            </form>
          </div>
        </Container>
      </div>
    </>
  );
};

export default ContactUs;
